import SearchIcon from '@components/icons/Search.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';

export const Search = () => {
  const { openModal } = useModalContext();

  return (
    <button
      type="button"
      aria-label="Search"
      className="flex min-h-11 min-w-11 items-center justify-center relative cursor-pointer p-[3px] hover:bg-tint hover:rounded-[5px] group"
      onClick={() => openModal(ModalNamesEnum.SearchModal)}
    >
      <SearchIcon className="w-6 h-6 [&>path]:fill-foreground-muted group-hover:[&>path]:fill-[var(--color-on-surface)]" />
    </button>
  );
};
